export default __webpack_public_path__ + "static/media/Non_Airfield_WorkOrder.3e327c5c.png";